import { Link, useLocation } from 'react-router-dom';
import {
  LayoutDashboard,
  ArrowDownToLine,
  ArrowUpFromLine,
  List,
  DollarSign,
  FileText,
  User,
  Wallet,
} from 'lucide-react';
import { clsx } from 'clsx';

const menuItems = [
  { icon: LayoutDashboard, label: 'Dashboard', path: '/' },
  { icon: ArrowDownToLine, label: 'Cash In', path: '/cash-in' },
  { icon: ArrowUpFromLine, label: 'Cash Out', path: '/cash-out' },
  { icon: List, label: 'Transacciones', path: '/transactions' },
  { icon: DollarSign, label: 'Comisiones', path: '/commissions' },
  { icon: FileText, label: 'Reportes', path: '/reports' },
  { icon: Wallet, label: 'Recarga Float', path: '/float/request' },
  { icon: User, label: 'Perfil', path: '/profile' },
];

export const AgentSidebar = () => {
  const location = useLocation();

  return (
    <aside className="hidden lg:flex lg:flex-col lg:w-64 bg-white border-r border-gray-200">
      <div className="flex-1 overflow-y-auto py-4">
        <nav className="space-y-1 px-3">
          {menuItems.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path;

            return (
              <Link
                key={item.path}
                to={item.path}
                className={clsx(
                  'flex items-center gap-3 px-4 py-3 rounded-lg transition-colors',
                  isActive
                    ? 'bg-primary-50 text-primary-700 font-medium'
                    : 'text-gray-700 hover:bg-gray-50'
                )}
              >
                <Icon size={20} />
                <span>{item.label}</span>
              </Link>
            );
          })}
        </nav>
      </div>
    </aside>
  );
};
